const CircleQuestion = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_iii_26_389)">
      <g clipPath="url(#clip0_26_389)">
        <path
          d="M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z"
          fill="#225AEA"
        />
        <rect width="64" height="64" rx="32" fill="url(#paint0_linear_26_389)" />
        <g opacity="0.4">
          <path
            d="M24.7019 8.67663C24.3355 7.31183 22.9259 6.48943 21.6043 6.99023C15.6098 9.25865 10.6843 13.6932 7.80115 19.4174C7.16435 20.6814 7.83475 22.1694 9.15475 22.675C10.4747 23.1822 11.9419 22.5134 12.6107 21.267C14.864 17.0577 18.5172 13.7678 22.9387 11.9662C24.2491 11.4318 25.0667 10.043 24.7019 8.67823V8.67663Z"
            fill="#F2F6FF"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.9999 20.3333C25.5566 20.3333 20.3333 25.5566 20.3333 31.9999C20.3333 38.4432 25.5566 43.6666 31.9999 43.6666C38.4432 43.6666 43.6666 38.4432 43.6666 31.9999C43.6666 25.5566 38.4432 20.3333 31.9999 20.3333ZM31.9999 28.4999C31.5597 28.4999 31.1747 28.7433 30.975 29.1084C30.6658 29.6737 29.9569 29.8813 29.3916 29.5721C28.8263 29.2629 28.6187 28.554 28.9279 27.9887C29.5203 26.9054 30.673 26.1666 31.9999 26.1666C33.7671 26.1666 34.9946 27.3407 35.3441 28.7204C35.6954 30.1074 35.1617 31.7234 33.5652 32.5217C33.3209 32.6438 33.1666 32.8935 33.1666 33.1666C33.1666 33.8109 32.6443 34.3333 31.9999 34.3333C31.3556 34.3333 30.8333 33.8109 30.8333 33.1666C30.8333 32.0097 31.4869 30.9521 32.5217 30.4347C33.0522 30.1694 33.1885 29.7129 33.0822 29.2934C32.9741 28.8665 32.6163 28.4999 31.9999 28.4999ZM31.9999 37.8333C32.6443 37.8333 33.1666 37.3109 33.1666 36.6666C33.1666 36.0223 32.6443 35.4999 31.9999 35.4999C31.3556 35.4999 30.8333 36.0223 30.8333 36.6666C30.8333 37.3109 31.3556 37.8333 31.9999 37.8333Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_iii_26_389"
        x="-4"
        y="-8"
        width="68"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="-4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_26_389" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_innerShadow_26_389" />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.113725 0 0 0 0 0.309804 0 0 0 0 0.843137 0 0 0 1 0" />
        <feBlend mode="normal" in2="effect1_innerShadow_26_389" result="effect2_innerShadow_26_389" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-8" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.862745 0 0 0 0 0.917647 0 0 0 0 0.996078 0 0 0 0.35 0" />
        <feBlend mode="normal" in2="effect2_innerShadow_26_389" result="effect3_innerShadow_26_389" />
      </filter>
      <linearGradient
        id="paint0_linear_26_389"
        x1="32"
        y1="0"
        x2="32"
        y2="64"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.16" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_26_389">
        <path
          d="M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)

export default CircleQuestion
